import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.v{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dq{background:var(--palette-white);}.ssr-plugin'
import '.ah{flex-grow:1;}.ssr-plugin'
import '.u{align-items:center;}.ssr-plugin'
import '.b0{max-width:77.5rem;}.ssr-plugin'
import '.fe{justify-content:stretch;}.ssr-plugin'
import '.bh{position:sticky;}.ssr-plugin'
import '.bi{top:0px;}.ssr-plugin'
import '.bj{z-index:10;}.ssr-plugin'
import '.ff{padding-block:1rem;}.ssr-plugin'
import '.fg{height:3rem;}.ssr-plugin'
import '.b8{justify-content:space-between;}.ssr-plugin'
import '.ba{flex-wrap:wrap;}.ssr-plugin'
import '.fh{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ej{margin-top:2rem;}.ssr-plugin'
import '.fi{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d r v e dq"
      >
        <div className="ah d u v e"
        >
          <div className="b0 d e fe bh bi bj dq"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="ff fg d b8 u ba"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fh d e r ej fi b0"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
